import './App.css';

import { useState, useEffect } from 'react';
import Utils from './utils';
import Countdown from './components/Countdown';

function App() {

  const [linkOpen, setLinkOpen] = useState(true);



  return (
    <div className="App">
      <div className="content-container">
        <div className='logo-container'>
          <svg className="logo" xmlns="http://www.w3.org/2000/svg"
            width="14.2222in" height="14.5972in"
            viewBox="0 0 1024 1051">
            <path id="Selection"
              fill="black" stroke="black" strokeWidth="1"
              d="M 51.00,21.46
           C 38.89,24.19 35.53,30.50 30.25,41.00
             22.49,56.42 18.21,77.73 18.00,95.00
             17.85,108.48 17.74,122.93 21.43,136.00
             25.44,150.22 36.05,168.40 43.95,181.00
             60.93,208.07 83.67,235.64 104.42,260.00
             104.42,260.00 142.08,305.00 142.08,305.00
             145.95,309.65 155.81,320.28 156.26,326.00
             156.53,329.37 154.20,333.16 152.57,336.00
             152.57,336.00 142.19,353.00 142.19,353.00
             129.49,373.51 117.38,395.06 107.31,417.00
             86.46,462.39 64.61,517.50 57.43,567.00
             54.45,587.54 54.97,608.29 55.00,629.00
             55.02,642.88 58.82,663.72 63.03,677.00
             71.71,704.39 100.24,756.04 113.30,785.00
             121.30,802.72 133.72,833.63 132.96,853.00
             131.32,894.83 83.83,899.95 52.00,903.72
             45.47,904.49 30.20,904.18 25.09,907.28
             17.61,911.81 16.89,923.82 23.21,929.61
             27.12,933.18 31.09,932.99 36.00,933.00
             36.00,933.00 80.00,933.00 80.00,933.00
             80.00,933.00 113.00,933.00 113.00,933.00
             113.00,933.00 151.00,933.00 151.00,933.00
             151.00,933.00 161.00,931.96 161.00,931.96
             161.00,931.96 170.00,931.96 170.00,931.96
             206.10,928.39 246.99,915.60 258.41,877.00
             260.47,870.03 261.97,861.26 262.00,854.00
             262.00,854.00 262.00,847.00 262.00,847.00
             261.71,822.59 249.43,798.22 236.68,778.00
             209.90,735.52 182.20,713.21 155.86,666.00
             141.57,640.38 142.96,615.15 143.00,587.00
             143.00,587.00 144.00,570.00 144.00,570.00
             144.00,570.00 145.83,542.00 145.83,542.00
             150.21,498.17 157.64,456.00 171.33,414.00
             175.27,401.92 178.84,389.52 184.32,378.00
             185.73,375.03 189.50,368.10 193.01,367.62
             195.84,367.24 199.17,371.19 201.00,373.00
             201.00,373.00 218.28,392.00 218.28,392.00
             218.28,392.00 288.72,473.00 288.72,473.00
             288.72,473.00 486.72,701.00 486.72,701.00
             486.72,701.00 578.83,807.00 578.83,807.00
             586.12,815.20 591.78,824.63 597.40,834.00
             608.48,852.47 617.75,871.06 623.27,892.00
             623.27,892.00 628.45,920.00 628.45,920.00
             629.32,924.22 630.56,928.70 635.02,930.40
             636.77,931.07 640.09,931.05 642.00,930.96
             653.62,930.42 658.50,922.47 663.24,913.00
             675.21,889.07 676.30,865.19 676.00,839.00
             675.72,814.98 663.05,790.59 650.00,771.00
             627.94,737.89 601.71,708.44 576.25,678.00
             576.25,678.00 550.87,648.00 550.87,648.00
             547.25,643.79 538.99,634.76 537.14,630.00
             533.59,620.84 535.89,608.65 536.00,599.00
             536.00,599.00 546.73,523.00 546.73,523.00
             546.73,523.00 571.25,369.00 571.25,369.00
             571.25,369.00 579.73,315.00 579.73,315.00
             580.44,310.18 581.61,298.59 586.04,295.94
             588.97,294.19 592.12,298.11 593.91,300.01
             598.62,304.98 605.89,315.88 609.23,322.00
             615.87,334.15 621.72,347.53 625.11,361.00
             627.04,368.69 627.48,381.99 631.85,387.94
             637.61,395.68 646.47,393.33 652.91,387.94
             663.34,379.33 668.43,364.79 671.63,352.00
             673.69,343.73 675.96,328.42 676.00,320.00
             676.00,320.00 676.00,302.00 676.00,302.00
             675.89,292.98 673.52,277.54 670.64,269.00
             657.15,228.84 616.59,201.47 589.17,171.00
             575.47,155.78 548.25,110.42 536.60,91.00
             527.41,75.69 515.77,57.23 508.87,41.00
             505.15,32.23 503.86,22.52 492.00,21.19
             481.08,19.96 472.29,32.51 467.78,41.00
             455.88,63.42 456.71,91.30 457.00,116.00
             457.46,154.83 489.33,187.83 513.28,215.00
             513.28,215.00 534.00,237.00 534.00,237.00
             536.63,240.06 541.03,245.22 542.30,249.00
             543.27,251.88 543.03,258.71 543.00,262.00
             543.00,262.00 540.13,284.00 540.13,284.00
             540.13,284.00 532.42,333.00 532.42,333.00
             532.42,333.00 511.25,467.00 511.25,467.00
             511.25,467.00 498.42,550.00 498.42,550.00
             498.42,550.00 495.06,569.00 495.06,569.00
             494.35,571.25 492.93,574.80 489.96,574.38
             487.62,574.05 483.71,569.74 482.09,568.00
             482.09,568.00 464.00,547.00 464.00,547.00
             464.00,547.00 393.58,466.00 393.58,466.00
             393.58,466.00 123.27,155.00 123.27,155.00
             97.28,124.63 76.45,90.62 68.80,51.00
             66.58,39.47 67.67,19.32 51.00,21.46 Z
           M 832.00,696.21
           C 820.59,698.15 812.45,700.02 802.00,705.25
             794.45,709.02 787.37,713.75 781.00,719.29
             739.17,755.68 736.92,814.86 737.00,866.00
             737.00,866.00 738.04,878.00 738.04,878.00
             738.04,878.00 738.04,887.00 738.04,887.00
             739.61,902.13 741.95,917.51 746.67,932.00
             749.08,939.38 751.70,947.12 755.32,954.00
             771.48,984.71 801.82,1010.57 838.00,1011.00
             838.00,1011.00 853.00,1011.00 853.00,1011.00
             890.71,1010.56 921.30,983.34 937.24,951.00
             947.39,930.41 951.50,906.70 953.09,884.00
             953.09,884.00 954.00,873.00 954.00,873.00
             954.17,836.39 955.05,805.39 943.00,770.00
             929.87,731.47 895.91,696.51 853.00,696.21
             853.00,696.21 832.00,696.21 832.00,696.21 Z
           M 841.00,707.16
           C 841.00,707.16 847.00,707.16 847.00,707.16
             879.01,708.28 898.03,726.65 905.63,757.00
             909.42,772.16 911.02,787.48 912.09,803.00
             912.09,803.00 913.04,813.00 913.04,813.00
             913.04,813.00 913.04,825.00 913.04,825.00
             913.04,825.00 914.00,837.00 914.00,837.00
             914.00,837.00 914.00,869.00 914.00,869.00
             914.00,869.00 913.00,891.00 913.00,891.00
             912.98,900.99 910.50,923.89 908.75,934.00
             904.78,956.88 897.99,982.91 875.00,993.68
             866.85,997.50 857.89,999.00 849.00,999.83
             844.33,1000.27 842.41,999.68 838.00,999.15
             818.88,996.86 803.50,987.90 793.47,971.00
             789.06,963.55 785.24,949.64 783.61,941.00
             781.08,927.59 778.02,900.42 778.00,887.00
             778.00,887.00 778.00,866.00 778.00,866.00
             778.00,866.00 777.04,855.00 777.04,855.00
             777.04,855.00 778.00,841.00 778.00,841.00
             778.00,841.00 778.00,820.00 778.00,820.00
             778.00,820.00 778.91,808.00 778.91,808.00
             778.91,808.00 781.87,777.00 781.87,777.00
             785.68,749.55 792.40,724.84 820.00,712.31
             827.63,708.85 832.97,708.46 841.00,707.16 Z" />
          </svg>
        </div>

        {linkOpen &&

          <div className='link-container'>
            <a href="https://utdallas.qualtrics.com/jfe/form/SV_3CVhWBZdYLGvjv0" className='link-button'>
              Apply
            </a >
            <a href="https://discord.gg/WpcQ6jSt" className='link-button'>
              Chat
            </a >
          </div>

        }

        
      </div>
    </div>
  );
}

export default App;

// classname="link" href="https://utdallas.qualtrics.com/jfe/form/SV_3CVhWBZdYLGvjv0"